export class InboxCase {
  activities: Array<Activities>;
  caseChannel: CaseChannel;
  caseId: string;
  caseNumber: string;
  caseType: CaseType;
  companyMessage: string;
  companyName: string;
  consecutivelyOfferNumber: number;
  contact: CustomerInfo;
  createdAt: string;
  customer: CustomerInfo;
  cvr: string;
  deliveryAddress: CustomerInfo;
  departmentId: string;
  description: string;
  disableNotifications: string;
  doneBy: Array<Company>;
  ean: string;
  externalId: string;
  files: Array<string>;
  fitter: Fitter;
  internalNote: string;
  invoice: CustomerInfo;
  isOfferRequest: boolean;
  lastModified: string;
  offerNumber: number;
  orderNumber: string;
  origin: Origin;
  partnerCases: Array<PartnerCases>;
  propertyInfo: PropertyInfo;
  propertyName: string;
  requisitionNumber: string;
  responsible: Responsible;
  startTime: string;
  status: Status;
  tasks: Array<CaseTask>;
  title: string;
  transferId: string;
  transferType: string;
  transferTypeId: string;
  transferStatusId: string;
  transferStatus: string = 'pending';
  unreadMessage: boolean;
  variationOrderNumber: number;
  vorRef: string;
}

export class CaseTask {
  startDateTime: Date | null = null;
  endDateTime: string;
  fitter: KeyValue = new KeyValue();
  caseTaskStatus: KeyValue;
  caseTaskType: KeyValue;
  taskId: string | null = null; 
  startDate: string;
  startTime: string = '08:00';
  hours: number = 1;
  minutes: number = 0;
}

export class KeyValue {
  key: string | null = null;
  value: string | null = null;
}

export class Status {
  caseStatusId: string;
  name: string;
}

export class CustomerInfo {
  id: string;
  customerId: string;
  externalId: string;
  customerNumber: string;
  name: string;
  address: string;
  zipCode: string;
  city: string;
  phone: string;
  mobile: string;
  email: string;
  ean: string;
  cvr: string;
}

export class Responsible {
  responsibleId: string;
  name: string;
}

export class Fitter {
  fitterId: string;
  name: string;
}

export class Origin {
  originId: string;
  url: string;
  name: string;
}

export class CaseType {
  id: string;
  name: string;
}

export class Company {
  companyId: string;
  name: string;
}

export class PartnerCases {
  caseId: string;
}

export class CaseChannel {
  name: string;
  icon: string;
}

export class PropertyInfo {
  propertyNumber: string;
  propertyLeaseNumber: string;
}

export class Activities {
  date: string;
  description: string;
}

export class SendCaseSettings {
  caseId: string;
  parentCaseId: string;
  invoiceId: string;
  contactId: string;
  responsibleId: string;
  eResponsibleId: string;
  integrationId: string;
  caseTypeId: number;
  osDepartmentId: number;
  osStatus: number;
  minubaCaseType: string;
  customerGroupId: number;
  economySystemGroupId: number;
  foremanId: string;
  eOrderGroupId: number;
  eDimensionCarrierId: number;
  eDimensionDepartmentId: number;
  ePriceGroupId: number;
  eProfitGroupId: number;
  eName: string;
  paymentTermsId: number;
  eUserEmail: string;
  eDimensionPurposeId: number;
  eProjectType: string;
  sendFiles: boolean;
}

export class CompanyInformation {
  public name: string;
  public address: string;
  public companyAddress: string;
  public companyZipCode: string;
  public companyCity: string;
  public id: string;
  public phone: string;
  public logo: string;
  public email: string;
  public companyLanguage: string = 'da-DK';
  public companyNumber: number;
  public companyType: string;
  public googleAnalyticsId: string;
  public originId: string;
  public vat: string;
  public base64?: string;
  public website: string;
}

export class MinubaSettings {
  success: string;
  ordertypes: Array<MinubaOrderType>;
}

export class MinubaOrderType {
  name: string;
  description: string;
  id: string;
  price: string;
  department: string;
  orderTypeMaterials: string[];
}